<template>
    <div>
        <div>
            <b-row>
                <b-col>
                    <a href="/adm/rotas" class="btn btn-primary"><i class="fa fa-map"></i> Voltar</a>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Início da Rota</label>
                        <date-picker v-model="dtinicio" :config="datePickerConfig"></date-picker>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Fim da Rota</label>
                        <date-picker v-model="dtfim" :config="datePickerConfig"></date-picker>
                    </div>
                </div>
            </b-row>
            <b-row class="mt-3" v-if="listaRota.length > 0">
                <b-col class="col-md-12">
                    <b-card no-body>
                        <b-tabs active-nav-item-class="font-weight-bold bg-primary text-secondary"
                            active-tab-class="font-weight-bold" v-model="tabEdit" card>
                            <b-tab title="Rotas" title-link-class="text-primary">
                                <div class="row">
                                    <div class="col-12 card p-3">
                                        <table class="table table-hover">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th>Endereco</th>
                                                    <th>Cidade</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(rota, i) in orderedUsers" :key="rota.id">
                                                    <td class="btn-group">
                                                        <button class="btn btn-primary" @click="
                                                            addDetalhamento(
                                                                rota.coordenadas,
                                                                rota.cidade,
                                                                rota.subrota,
                                                                rota.km,
                                                                rota.id
                                                            )
                                                            ">
                                                            <i class="fa fa-map-marker"></i>
                                                        </button>
                                                        <button class="btn btn-primary" @click="removeRota(rota.id)">
                                                            <i class="fas fa-trash"></i>
                                                        </button>
                                                    </td>
                                                    <td>{{ rota.endereco }}</td>
                                                    <td>{{ rota.cidade }}</td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr class="text-primary">
                                                    <td>
                                                        <button @click="confirmaRota" class="btn btn-primary">
                                                            Salvar
                                                        </button>
                                                    </td>
                                                    <td>Total Km {{ totalKM }}</td>
                                                    <td></td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-12">
                                        <h3 class="text-info">Definindo rotas</h3>
                                        <label>Informe o endereço do Hotel.</label>
                                        <input class="form-control" @keyup="getAddress" type="text" v-model="busca" />
                                        <div class="list-group" v-if="listaBusca.length > 0">
                                            <div class="list-group-item" v-for="(list, index) in listaBusca" :key="index">
                                                <a href="#" @click="addRota(list.coordenadas)">{{ index + 1 }} - {{
                                                    list.endereco }}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>
                            <b-tab title="Sub Rotas" title-link-class="text-primary">
                                <div class="row">
                                    <div class="col-md-12" v-if="listaSubRota.length > 0">
                                        <div class="list-group">
                                            <div class="list-group-item active">
                                                <i class="fa fa-map-pin"></i> Sub Rotas
                                            </div>
                                            <div class="list-group-item">
                                                <table class="table table-hover">
                                                    <thead>
                                                        <tr>
                                                            <td>Endereço</td>
                                                            <td>Cidade</td>
                                                            <td>Data</td>
                                                            <td>Objetivo</td>
                                                            <td>Cliente</td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(list, idx) in orderSubrota" :key="idx">
                                                            <!--<td><button class="btn btn-primary" @click="rmSubRota(list.id)"><i class="fas fa-trash"></i></button></td>-->
                                                            <td>{{ list.endereco }}</td>
                                                            <td>{{ list.cidade }}</td>
                                                            <td>
                                                                <div class="form-group" v-if="!list.id">
                                                                    <date-picker v-model="list.dtlocal"
                                                                        :config="datePickerConfig"></date-picker>
                                                                </div>
                                                                <div v-if="list.dtlocal">
                                                                    {{ list.dtlocal }}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="form-group" v-if="!list.id">
                                                                    <select v-model="list.tipo" class="form-control">
                                                                        <option value="PROSPECTO">Prospecto</option>
                                                                        <option value="RECUPERACAO">
                                                                            Recuperação
                                                                        </option>
                                                                        <option value="NEGOCIACAO">Negociação</option>
                                                                        <option value="OUTROS">Outros</option>
                                                                        <option value="HOTEL">Hotel</option>
                                                                    </select>
                                                                </div>
                                                                <div v-if="list.tipo">
                                                                    {{ list.tipo }}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="form-group" v-if="!list.id">
                                                                    <input v-model="list.nome" type="text"
                                                                        class="form-control" />
                                                                </div>
                                                                <div v-if="list.nome">
                                                                    {{ list.nome }}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="form-group">
                                                                    <button class="btn btn-primary" @click="
                                                                        addArraySubRota(
                                                                            idx,
                                                                            list.nome,
                                                                            list.dtlocal,
                                                                            list.tipo
                                                                        )
                                                                        " v-if="listaSubRota.length > 0 && list.id === 0"
                                                                    >
                                                                        <i class="fa fa-plus-circle"></i>
                                                                    </button>
                                                                    <button class="btn btn-success"
                                                                        v-if="listaSubRota.length > 0 && list.id > 0">
                                                                        <i class="fa fa-check"></i>
                                                                    </button>
                                                                    <button class="btn btn-primary"
                                                                        @click="rmSubRota(list.id)">
                                                                        <i class="fas fa-trash"></i>
                                                                    </button>
                                                                    <!--<button class="btn btn-primary" @click="excluiSubRota" v-if="listaSubRota.length > 0">Excluir</button>-->
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <td></td>
                                                            <td></td>
                                                            <td class="text-primary">
                                                                Km extra: {{ totalSubRota }}
                                                            </td>
                                                            <td></td>
                                                            <td></td>
                                                            <td>
                                                                <button class="btn btn-primary"
                                                                    @click="atualizakmExtra(roteiro_id)">
                                                                    Concluir SubRota
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="row"></div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <input class="form-control" placeholder=" informe um endereço"
                                                @keyup="getAddress" type="text" v-model="busca" />
                                            <div class="list-group" v-if="listaBusca.length > 0">
                                                <div class="list-group-item" v-for="(list, index) in listaBusca"
                                                    :key="index">
                                                    <a href="#" @click="addMarker(list.coordenadas)">{{ index + 1 }} - {{
                                                        list.endereco }}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>
                        </b-tabs>
                    </b-card>
                </b-col>
            </b-row>
            <div class="row mt-3" style="width: 100%; height: 600px">
                <div class="center-block col-md-12">
                    <l-map ref="rota" :zoom="zoom" :center="inicio" style="height: 70%">
                        <l-tile-layer :url="url" :attribution="attribution" />
                        <v-geosearch :options="geosearchOptions"></v-geosearch>
                        <l-marker v-for="marker in markers" :draggable="marker.draggable" :lat-lng="marker.position"
                            :key="marker.id">
                            <l-popup :content="marker.title"></l-popup>
                        </l-marker>
                    </l-map>
                </div>
            </div>
        </div>

        <!------------------------------------------------------ Modal  ----------------------------- -->
        <b-modal v-model="modalAddRota" title="Resumo da rota" size="xl">
            <b-card>
                <b-card-body>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="list-group">
                                <div class="list-group-item">
                                    Total de Combustível: R$ {{ totalCombustivel.toFixed(2) }}
                                    <small class="text-danger">
                                        {{ totalLitros.toFixed(2) }} Litros
                                    </small>
                                </div>
                                <div class="list-group-item">
                                    Total Hospedagem : R$ {{ totalHospedagem }}
                                    <small class="text-danger">
                                        {{ parametros.hospedagem }} a diária
                                    </small>
                                </div>
                                <div class="list-group-item">
                                    Total Alimentação : R$ {{ totalAlimentacao }}
                                    <small class="text-danger">
                                        {{ parametros.alimentacao }} a diária
                                    </small>
                                </div>
                                <div class="list-group-item bg bg-secondary">
                                    Total Pedágio : R$ {{ totalPedagio }}
                                </div>
                                <div class="list-group-item active">
                                    Total : R$ {{ (valorTOTAL + totalPedagio).toFixed(2) }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <table class="table-stripe table-hover">
                            <thead>
                                <tr>
                                    <th>Rota</th>
                                    <th>Endereco</th>
                                    <th>Cidade</th>
                                    <th>Pedágio</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(rota, i) in orderedUsers" :key="i">
                                    <td>{{ i + 1 }}</td>
                                    <td>{{ rota.endereco }}</td>
                                    <td>{{ rota.cidade }}</td>
                                    <td>
                                        <span>
                                            <input type="text" v-mask="['#.##', '##.##', '###.##', '###.##']"
                                                v-model="rota.pedagio" v-show="!rota.showInput" />
                                        </span>
                                        <span v-if="rota.showInput">
                                            {{ rota.pedagio }}
                                        </span>
                                    </td>
                                    <td>
                                        <b-button variant="success" @click="addPedagio(rota.pedagio, i)"
                                            v-if="!rota.showInput">
                                            <i class="fa fa-check"></i>
                                        </b-button>
                                        <b-button variant="danger" @click="addPedagio(0, i)" v-if="rota.showInput">
                                            <i class="fas fa-window-close"></i>
                                        </b-button>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr class="text-primary">
                                    <td>-</td>
                                    <td>Total Km {{ totalKM }}</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </b-card-body>
            </b-card>
            <template #modal-footer>
                <b-button size="sm" variant="primary" @click="salvaRota">Confirmar</b-button>
                <b-button size="sm" variant="danger" @click="modalAddRota = false">Cancelar</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import Vue from 'vue';


//import L from 'leaflet';
import {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LPolyline,
    LIcon,
} from "vue2-leaflet";

import 'leaflet/dist/leaflet.css';
import { Icon } from 'leaflet';
import {
    OpenStreetMapProvider
} from "leaflet-geosearch";
import VGeosearch from "vue2-leaflet-geosearch";
import {
    LeafleatRoutingMachine
} from "leaflet-routing-machine/dist/leaflet-routing-machine.js";
import DatePicker from "vue-bootstrap-datetimepicker/src/component";
import "./Bing/Control.BingGeocoder.css";
import "./Bing/Control.BingGeocoder";

export default {
    name: "Rotas",
    components: {
        DatePicker,
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
        LPolyline,
        VGeosearch,
    },
    data() {
        return {
            modalAddRota: false,
            tabEdit: 0,
            zoom: 11,
            inicio: this.getCoordenadas(),
            url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
            attribution: '&copy; <a href="#">Abelha Rainha</a> T.I',
            marker: this.getCoordenadas(),
            currentZoom: 11,
            currentCenter: this.getCoordenadas(),
            busca: "",
            listaBusca: [],
            rota: {},
            local: "",
            arrayLayers: [],
            listaRota: [],
            dtvisita: "",
            dtinicio: "",
            nomecliente: "",
            nomeHotel: "",
            dtfim: "",
            showSubrota: false,
            tipo_visita: "",
            rotasSelecionadas: [],
            listaSubRota: [],
            subRotasSelecionadas: [],
            rotaSelecionada: {
                lat: 0,
                lng: 0,
            },
            totalSubRota: 0,
            totalKM: 0,
            valorTOTAL: 0,
            totalCombustivel: 0,
            totalLitros: 0,
            qtdHospedagem: 0,
            totalHospedagem: 0,
            totalAlimentacao: 0,
            totalPedagio: 0,
            markers: [],
            marks: [],
            cidades: [],
            geosearchOptions: {
                provider: new OpenStreetMapProvider(),
                showMarker: true,
                searchLabel: "Digite o Endereço",
                marker: {
                    icon: new L.Icon.Default(),
                    draggable: false,
                },
                autoClose: true,
            },
            datePickerConfig: {
                format: "DD/MM/YYYY",
                showClose: true,
            },
            parametros: {
                kmXdia: 0,
                kmXlitro: 0,
                kmExtra: 0,
                alimentacao: 0,
                hospedagem: 0,
                combustivel: 0,
            },
            filtro: "listar",
            roteiro_id: 0,
        };
    },
    methods: {
        confirmaRota() {
            var vm = this;
            vm.getParametros();
            if (this.listaRota.length <= 0) {
                this.$swal("Ops..", "Por Favor, Crie uma rota primeiro.", "error");
                return;
            }
            vm.getCalc();
            vm.listaRota.forEach(function (a, c) {
                a.showInput = false;
            });
            vm.modalAddRota = true;
        },
        salvaRota() {
            var vm = this;
            $(".loading").show();

            var data = {
                edita_id: $("#idRota").val(),
                rota: vm.orderedUsers,
                total: vm.valorTOTAL,
                distance: vm.totalKM,
                dtinicio: vm.dtinicio.format("YYYY-MM-DD"),
                dtfim: vm.dtfim.format("YYYY-MM-DD"),
                alimentacao: vm.totalAlimentacao,
                hospedagem: vm.totalHospedagem,
                combustivel: vm.totalCombustivel,
            };
            //console.log(data);

            axios
                .post("/adm/rotas/save", data)
                .then(function (response) {
                    let obj = response.data;
                    vm.getLoad();
                    //console.log(obj);
                    $(".loading").hide();
                })
                .catch(function (error) {
                    $(".loading").hide();
                    //vm.$swal('Ops',error.response.data.errors,'error')
                    console.log(error.response.data.errors);
                });
        },
        getCalc() {
            var vm = this;
            var dtinicio = "";
            var dtfim = "";
            if (typeof this.dtinicio !== "undefined") {
                if (typeof this.dtinicio === "object") {
                    dtinicio = this.dtinicio;
                } else {
                    dtinicio = moment(this.dtinicio.split("/").reverse().join("-"));
                }
            }
            if (typeof this.dtfim !== "undefined") {
                if (typeof this.dtfim === "object") {
                    dtfim = this.dtfim;
                } else {
                    dtfim = moment(this.dtfim.split("/").reverse().join("-"));
                }
            }
            vm.dtfim = dtfim;
            vm.dtinicio = dtinicio;
            var timeDiff = moment(vm.dtinicio.format("YYYYMMDD"), "YYYYMMDD").from(vm.dtfim.format("YYYYMMDD"), "YYYYMMDD");
            vm.totalLitros = vm.totalKM / vm.parametros.kmXlitro;
            vm.qtdHospedagem = parseInt(timeDiff);
            //console.log(vm.parametros);
            vm.totalCombustivel = vm.totalLitros * vm.parametros.combustivel;
            vm.totalHospedagem = vm.qtdHospedagem * vm.parametros.hospedagem;
            vm.totalAlimentacao = vm.parametros.alimentacao * vm.qtdHospedagem;
            vm.valorTOTAL =
                vm.totalCombustivel + vm.totalHospedagem + vm.totalAlimentacao;
        },
        getParametros() {
            //console.log('buscando parametros...');
            var vm = this;
            axios
                .get("/adm/parametros/rotas/list")
                .then(function (response) {
                    let obj = response.data;
                    vm.parametros = {
                        kmXdia: obj.km_dia,
                        kmXlitro: obj.km_litro,
                        kmExtra: obj.km_extra,
                        alimentacao: parseFloat(obj.valor_alimentacao).toFixed(2),
                        hospedagem: parseFloat(obj.valor_hospedagem).toFixed(2),
                        combustivel: parseFloat(obj.valor_combustivel).toFixed(2),
                    };
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        addRota(oObj) {
            var vm = this;
            var arrayRotas = [];
            var map = this.$refs.rota.mapObject;

            const newMarker = {
                id: vm.markers.length,
                position: L.latLng(oObj.latitude, oObj.longitude),
                draggable: true,
                visible: true,
                title: "",
                distance: 0,
            };
            vm.markers.push(newMarker);
            vm.busca = "";
            vm.listaBusca = [];

            vm.markers.forEach(function (v, i) {
                arrayRotas.push(v.position);
            });

            vm.rota = L.Routing.control({
                waypoints: arrayRotas,
                language: "pt-BR",
                routeWhileDragging: true,
                reverseWaypoints: true,
                showAlternatives: true,
                router: L.Routing.mapbox(
                    "pk.eyJ1IjoidGhpYWdvc2FsZXMiLCJhIjoiY2pwM3hlYTQ0MG10cjNwcDdmNjA3MDZiaSJ9.VuCofAu1XSyI7FjR76QtNg", {
                    language: "pt-BR"
                }
                ),
                altLineOptions: {
                    styles: [{
                        color: "black",
                        opacity: 0.15,
                        weight: 9
                    },
                    {
                        color: "white",
                        opacity: 0.8,
                        weight: 6
                    },
                    {
                        color: "blue",
                        opacity: 0.5,
                        weight: 2
                    },
                    ],
                },
            }).on("routeselected", function (e) {
                var route = e.route;
                vm.totalKM = parseFloat(route.summary.totalDistance / 1000).toFixed(1);
                vm.getMarkers(oObj.latitude, oObj.longitude);
            });
            vm.rota.addTo(map);
            vm.addLayer();
        },
        addArraySubRota(index, nome, dtlocal, tipo) {
            if (nome === "") {
                return this.$swal("Ops", "Por favor Informe um nome", "error");
            }
            if (dtlocal === "") {
                return this.$swal("Ops", "Por favor Informe uma data", "error");
            }
            if (tipo === "") {
                return this.$swal(
                    "Ops",
                    "Por favor Informe o motivo da visita",
                    "error"
                );
            }
            this.listaSubRota[index].nome = nome;
            this.listaSubRota[index].dtlocal = dtlocal;
            //alert(typeof dtlocal);
            this.listaSubRota[index].tipo = tipo;
            this.addSubRota(null, index);
        },
        removeRota(id) {
            var vm = this;
            var map = this.$refs.rota.mapObject;
            var arrayRotas = [];
            this.$swal({
                title: "Atenção",
                text: "Todas as subrotas vinculadas a esta marcação serão perdidas. Deseja continuar ?",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim, continuar.",
                cancelButtonText: "Não!",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    //this.$swal('Deleted', 'You successfully deleted this file', 'success')
                    $(".loading").show();
                    vm.getLoad();
                    axios
                        .get("/adm/rotas/delete/roteiro/" + id)
                        .then(function (response) {
                            let obj = response.data;
                            //vm.getLoad();
                            vm.cidades = [];
                            vm.markers.forEach(function (v, i) {
                                arrayRotas.push(v.position);
                            });
                            if (arrayRotas.length > 0) {
                                vm.cidades.push({
                                    id: "rota-" + arrayRotas.length,
                                    position: arrayRotas,
                                    visible: true,
                                    distance: 0,
                                    name: "",
                                });
                            }
                            L.Routing.control({
                                waypoints: arrayRotas,
                                routeWhileDragging: true,
                                reverseWaypoints: true,
                                showAlternatives: true,
                                router: L.Routing.mapbox(
                                    "pk.eyJ1IjoidGhpYWdvc2FsZXMiLCJhIjoiY2pwM3hlYTQ0MG10cjNwcDdmNjA3MDZiaSJ9.VuCofAu1XSyI7FjR76QtNg", {
                                    language: "pt-BR"
                                }
                                ),
                                language: "pt-BR",
                                altLineOptions: {
                                    styles: [{
                                        color: "black",
                                        opacity: 0.15,
                                        weight: 9
                                    },
                                    {
                                        color: "white",
                                        opacity: 0.8,
                                        weight: 6
                                    },
                                    {
                                        color: "blue",
                                        opacity: 0.5,
                                        weight: 2
                                    },
                                    ],
                                },
                            })
                                .on("routeselected", function (e) {
                                    var route = e.route;
                                    vm.totalKM = parseFloat(
                                        route.summary.totalDistance / 1000
                                    ).toFixed(2);
                                    var arrayPoints = route.waypoints;
                                    vm.getParametros();
                                    vm.getCalc();
                                })
                                .addTo(map);

                            if (obj.success) {
                                vm.salvaRota();
                                vm.$swal("OK", obj.success, "success");
                            }
                            $(".loading").hide();
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }
            });
        },
        getAddress(event) {
            var vm = this;
            if (vm.busca == "") {
                return;
            }
            vm.listaBusca = [];

            var data = {
                endereco: this.busca
            };
            axios
                .get("/adm/rotas/busca", {
                    params: data,
                })
                .then(function (response) {
                    vm.listaBusca = response.data;
                })
                .catch(function (error) {
                    console.log(error.response);
                });
        },
        addMarker(oObj, reload) {
            var vm = this;
            var arrayRotas = [];
            var map = this.$refs.rota.mapObject;

            const newMarker = {
                id: vm.markers.length,
                position: L.latLng(oObj.latitude, oObj.longitude),
                draggable: true,
                visible: true,
                title: "",
                distance: 0,
            };
            vm.markers.push(newMarker);
            if (typeof reload === "undefined") {
                vm.getAddSubrota(oObj.latitude, oObj.longitude);
            }
            vm.busca = "";
            vm.listaBusca = [];
            vm.cidades = [];

            vm.markers.forEach(function (v, i) {
                arrayRotas.push(v.position);
            });

            vm.arrayLayers.length > 1 ? vm.rota.remove(map) : null;

            vm.rota = L.Routing.control({
                waypoints: arrayRotas,
                routeWhileDragging: true,
                reverseWaypoints: true,
                showAlternatives: true,
                language: "pt-BR",
                geocoder: new L.Control.BingGeocoder(
                    "AtrGhmzn6VkB0pJt8ZQ9tnCiuf_2Zr2kubwg-RF-x7bNeeJnSklS1y4J8_ttmCkm", {
                    locate: "pt-BR"
                }
                ),
                altLineOptions: {
                    styles: [{
                        color: "black",
                        opacity: 0.15,
                        weight: 9
                    },
                    {
                        color: "white",
                        opacity: 0.8,
                        weight: 6
                    },
                    {
                        color: "blue",
                        opacity: 0.5,
                        weight: 2
                    },
                    ],
                },
            }).on("routeselected", function (e) {
                var route = e.route;
                vm.subRotasSelecionadas = [];
                vm.totalSubRota = parseFloat(
                    route.summary.totalDistance / 1000
                ).toFixed(2);
            });
            vm.rota.addTo(map);
            vm.addLayer();
        },

        getAddSubrota(lat, lng, id, nome, dtlocal, motivo, obs) {
            //  console.log("ADICIONANDO subrotas....");
            var vm = this;
            var position = {
                latitude: lat,
                longitude: lng
            };
            axios
                .get("/adm/rotas/latlng", {
                    params: position,
                })
                .then(function (response) {
                    var address = response.data;
                    var validaArray = vm.RemoveDuplicado(lat, lng);
                    if (validaArray >= 0) {
                        vm.listaSubRota[validaArray].endereco = address.endereco;
                        vm.listaSubRota[validaArray].cidade = address.cidade;
                        vm.listaSubRota[validaArray].dtlocal = dtlocal ?
                            moment(dtlocal) :
                            "";
                        vm.listaSubRota[validaArray].nome = nome ? nome : "";
                        vm.listaSubRota[validaArray].tipo = motivo ? motivo : "";
                        vm.listaSubRota[validaArray].distance = vm.totalSubRota;
                        vm.listaSubRota[validaArray].id = id ? id : 0;
                        vm.listaSubRota[validaArray].obs = obs ? obs : "";
                    } else {
                        vm.listaSubRota.push({
                            endereco: address.endereco,
                            cidade: address.cidade,
                            dtlocal: dtlocal ? moment(dtlocal).format("D/M/Y") : "",
                            nome: nome ? nome : "",
                            tipo: motivo ? motivo : "",
                            coordenadas: {
                                latitude: lat,
                                longitude: lng
                            },
                            distance: vm.totalSubRota,
                            id: id ? id : 0,
                            obs: obs ? obs : "",
                        });
                    }
                })
                .catch(function (error) {
                    console.log(error.response);
                });
        },
        addLayer() {
            var map = this.$refs.rota.mapObject;
            this.arrayLayers.push(map._layers);
        },
        addPedagio(value, id) {
            var vm = this;
            vm.listaRota[id].pedagio = value;
            vm.listaRota[id].showInput = value === 0 ? false : true;
            vm.totalPedagio = 0.0;
            vm.listaRota.forEach(function (a, s) {
                // console.log(typeof a.pedagio);
                vm.totalPedagio += a.pedagio ? parseFloat(a.pedagio) : 0;
            });
        },

        getLoad() {
            var id = $("#idRota").val();
            var vm = this;
            var arrayRotas = [];
            var map = this.$refs.rota.mapObject;
            var data = {
                roteiro: this.filtro,
            };

            this.listaRota = [];
            this.markers = [];
            this.dtinicio = moment($("#dtInicio").val());
            this.dtfim = moment($("#dtFim").val());
            this.totalKM = $("#KMTotal").val();
            this.valorTOTAL = parseFloat($("#valorTotal").val());
            this.totalHospedagem = parseFloat($("#valorHospedagem").val());
            this.totalAlimentacao = parseFloat($("#valorAlimentacao").val());
            this.totalCombustivel = parseFloat($("#valorCombustivel").val());
            this.dtvisita = this.dtinicio;

            if (id == "") {
                return;
            }

            $(".loading").show();
            vm.listaSubRota = [];
            axios
                .get("/adm/rotas/edit/" + id, {
                    params: data,
                })
                .then(function (response) {
                    let obj = response.data;
                    var tam = obj.length;

                    obj.forEach(function (z, x) {
                        vm.getAddLatLong(z.latitude, z.longitude, z.id, z.total_kmextra);
                        vm.markers.push({
                            id: z.id,
                            position: L.latLng(z.latitude, z.longitude),
                            draggable: true,
                            visible: true,
                            title: "",
                            distance: 0,
                        });
                        if (x + 1 === tam) {
                            vm.markers.forEach(function (v, i) {
                                arrayRotas.push(v.position);
                            });

                            vm.rota = L.Routing.control({
                                waypoints: arrayRotas,
                                routeWhileDragging: true,
                                reverseWaypoints: true,
                                showAlternatives: true,
                                router: L.Routing.mapbox(
                                    "pk.eyJ1IjoidGhpYWdvc2FsZXMiLCJhIjoiY2pwM3hlYTQ0MG10cjNwcDdmNjA3MDZiaSJ9.VuCofAu1XSyI7FjR76QtNg", {
                                    language: "pt-BR"
                                }
                                ),
                                language: "pt-BR",
                                altLineOptions: {
                                    styles: [{
                                        color: "black",
                                        opacity: 0.15,
                                        weight: 9
                                    },
                                    {
                                        color: "white",
                                        opacity: 0.8,
                                        weight: 6
                                    },
                                    {
                                        color: "blue",
                                        opacity: 0.5,
                                        weight: 2
                                    },
                                    ],
                                },
                            })
                                .on("routeselected", function (e) {
                                    var route = e.route;
                                    vm.totalKM = parseFloat(
                                        route.summary.totalDistance / 1000
                                    ).toFixed(2);
                                })
                                .addTo(map);
                        }
                    });
                    vm.addLayer();
                    $(".loading").hide();
                })
                .catch(function (error) {
                    $(".loading").hide();
                    console.log(error.response);
                });
        },
        //Funcao que cria array com dados da rota, para exibir ao usuário.
        getMarkers(lat, lng) {
            var vm = this;
            //vm.listaRota = [];
            if (typeof lat === "undefined" || typeof lng === "undefined") {
                return;
            }
            vm.getLoad();
            vm.getAddLatLong(lat, lng);
        },
        getAddLatLong(lat, lng, id, km) {
            var vm = this;
            var data = {
                latitude: lat,
                longitude: lng
            };

            axios
                .get("/adm/rotas/latlng", {
                    params: data,
                })
                .then(function (response) {
                    let obj = response.data;
                    vm.listaRota.push({
                        id: typeof id === "undefined" ? vm.listaRota.length + 1 : id,
                        endereco: obj.endereco,
                        cidade: obj.cidade,
                        coordenadas: obj.coordenadas,
                        km: km ? km : null,
                    });
                    //console.log(vm.listaRota);
                })
                .catch(function (error) {
                    console.log(error.response);
                });
        },
        //COORDENADAS ABELHA RAINHA.
        getCoordenadas() {
            var latitude = -16.755669; //$('#latitude').val();
            var longtude = -49.242341; //$('#longitude').val();
            return L.latLng(latitude, longtude);
        },
        getRoteiroID(id) {
            // console.log("verificando roteiro para carregar subrotas...");
            var vm = this;
            var data = {
                RoteiroById: id
            };
            vm.roteiro_id = id;
            vm.listaSubRota = [];
            axios
                .get("/adm/rotas/list", {
                    params: data,
                })
                .then(function (response) {
                    let obj = response.data;
                    // console.log(obj);
                    vm.totalSubRota = obj.total_kmextra ?
                        parseFloat(obj.total_kmextra) :
                        0;
                    if (obj.lenght > 0) {
                        vm.markers = [];
                    }

                    obj.forEach(function (s, d) {
                        vm.getAddSubrota(
                            s.latitude,
                            s.longitude,
                            s.id,
                            s.nome,
                            s.data_vizita,
                            s.motivo,
                            s.obs
                        );
                        vm.addMarker({
                            latitude: s.latitude,
                            longitude: s.longitude
                        },
                            true
                        );
                    });
                })
                .catch(function (error) {
                    console.log(error.response);
                });
        },
        RemoveDuplicado(lat, lng) {
            var vm = this;
            vm.listaSubRota.forEach(function (l, i) {
                var obj = l.coordenadas;
                if (obj.latitude == lat && obj.longitude == lng) {
                    return i;
                }
            });
            return -1;
        },
        atualizakmExtra(id) {
            // console.log("atualizando km Extra");
            var vm = this;
            axios
                .post("/adm/rotas/kmextra", {
                    kmExtra: vm.totalSubRota,
                    roteiro_id: id,
                })
                .then(function (response) {
                    let obj = response.data;
                    console.log(obj);
                    window.location.reload(1);
                })
                .catch(function (error) {
                    console.log(error.response);
                });
        },
        linkClass(idx) {
            if (this.tabEdit === idx) {
                return ["bg-primary", "text-light"];
            } else {
                return ["bg-light", "text-info"];
            }
        },
        addDetalhamento(latLng, cidade, subrota, km, id) {
            // console.log("adicionando detalhamento ....");
            var map = this.$refs.rota.mapObject;
            var objLtLg = "";
            this.showSubrota = true;
            this.getRoteiroID(id);
            this.addLayer();
            $(".loading").show();
            this.tabEdit = 1;
            var vm = this;
            //vm.totalSubRota = parseFloat(km).toFixed(2);
            if (vm.rotaSelecionada.lat === 0) {
                vm.rotaSelecionada = {
                    lat: latLng.latitude,
                    lng: latLng.longitude,
                };
            } else {
                if (vm.rotaSelecionada.lat !== latLng.latitude) {
                    $(".loading").hide();
                    vm.$swal({
                        title: "Atenção",
                        text: "É importante que todos os dados da subrota sejam salvos, antes de mudar de cidade. Deseja continuar?",
                        type: "info",
                        showCancelButton: true,
                        confirmButtonText: "Sim, continuar.",
                        cancelButtonText: "Não!",
                        showCloseButton: true,
                        showLoaderOnConfirm: true,
                    }).then((result) => {
                        if (result.value) {
                            vm.rotaSelecionada = {
                                lat: latLng.latitude,
                                lng: latLng.longitude,
                            };
                        }
                    });
                }
            }
            vm.arrayLayers.length > 1 ? vm.rota.remove(map) : null;
            objLtLg = L.latLng(vm.rotaSelecionada.lat, vm.rotaSelecionada.lng);
            vm.roteiro_id = id ? id : 0;
            vm.zoom = 11;
            vm.currentZoom = 11;
            vm.currentCenter = objLtLg;
            vm.inicio = objLtLg;
            vm.markers = [];
            vm.marker = objLtLg;

            var arrayRotas = [];

            if (vm.listaSubRota.length > 0) {
                // console.log("varrendo lista de subrota...");
                vm.markers = [];
                vm.listaSubRota.forEach(function (d, f) {
                    //console.log(d);
                    vm.markers.push({
                        id: d.id,
                        position: L.latLng(d.coordenadas),
                        draggable: true,
                        visible: true,
                        title: d.nome,
                    });
                });
                vm.busca = "";
                vm.listaBusca = [];
                vm.cidades = [];
                vm.markers.forEach(function (v, i) {
                    arrayRotas.push(v.position);
                });
                if (arrayRotas.length > 0) {
                    vm.cidades.push({
                        id: "rota-" + arrayRotas.length,
                        position: arrayRotas,
                        visible: true,
                        distance: 0,
                    });
                }
                vm.arrayLayers.length > 1 ? vm.rota.remove(map) : null;

                vm.rota = L.Routing.control({
                    waypoints: arrayRotas,
                    routeWhileDragging: true,
                    reverseWaypoints: true,
                    showAlternatives: true,
                    router: L.Routing.mapbox(
                        "pk.eyJ1IjoidGhpYWdvc2FsZXMiLCJhIjoiY2pwM3hlYTQ0MG10cjNwcDdmNjA3MDZiaSJ9.VuCofAu1XSyI7FjR76QtNg", {
                        language: "pt-BR"
                    }
                    ),
                    language: "pt-BR",
                    altLineOptions: {
                        styles: [{
                            color: "black",
                            opacity: 0.15,
                            weight: 9
                        },
                        {
                            color: "white",
                            opacity: 0.8,
                            weight: 6
                        },
                        {
                            color: "blue",
                            opacity: 0.5,
                            weight: 2
                        },
                        ],
                    },
                }).on("routeselected", function (e) {
                    var route = e.route;
                    vm.subRotasSelecionadas = [];
                    vm.totalSubRota = parseFloat(route.summary.totalDistance / 1000);
                    // console.log(vm.totalSubRota);
                    var arrayPoints = route.waypoints;
                    //console.log('add points')
                    //console.log(arrayPoints);
                    //array com as cordenadas da Rota.
                    arrayPoints.forEach(function (a, x) {
                        vm.subRotasSelecionadas.push({
                            lat: a.latLng.lat,
                            lng: a.latLng.lng,
                        });
                        vm.getAddSubrota(a.latLng.lat, a.latLng.lng);
                    });
                });
                //console.log(L.Routing);
                $(".loading").hide();
                vm.rota.addTo(map);
                vm.addLayer();
            } else {
                console.log(
                    "adicinando markes.. ja que a variavel lista subrotas e =" +
                    vm.listaSubRota.length
                );
                vm.markers = [{
                    id: 0,
                    position: objLtLg,
                    draggable: true,
                    visible: true,
                    title: cidade,
                },];
            }
            $(".loading").hide();
            vm.rota.addTo(map);
            vm.addLayer();
        },
        addSubRota(pressOk, idx) {
            if (this.listaSubRota.length <= 0) {
                this.$swal("Ops", "Nenhuma SubRota foi selecionada.", "error");
                return;
            }
            var vm = this;
            var subrota = vm.listaSubRota[idx];
            var data = {
                coordenadas: subrota.coordenadas,
                nome: subrota.nome,
                data: moment(subrota.dtlocal, "DD/MM/YYYY").format("YYYY-MM-DD"),
                tipo: subrota.tipo,
                subrota_id: subrota.id,
                km_extra: this.totalSubRota,
            };
            var idRota = $("#idRota").val();
            //alert(data.data);
            //console.log(data);
            axios
                .post("/adm/rotas/edit/" + vm.roteiro_id + "/addsubrota", data)
                .then(function (response) {
                    let obj = response.data;
                    //console.log(obj);
                    if (obj.id) {
                        vm.listaSubRota[idx].id = obj.id;
                    }
                    pressOk ? vm.$swal("Ok", obj.success, "success") : null;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        rmSubRota(id) {
            var vm = this;
            var rotaID = $("#idRota").val();
            vm.$swal({
                title: "Realmente dessa deletar esta visita?",
                text: "Esta ação não poderá ser revertida",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim, Deletar!",
                cancelButtonText: "Não, cancelar!",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    axios
                        .post("/adm/rotas/rmsubrota", {
                            id: id
                        })
                        .then(function (response) {
                            let obj = response.data;

                            vm.getRoteiroID(vm.roteiro_id);

                            $(".loading").hide();
                            vm.$swal("Ok", obj.success, "success");
                        })
                        .catch(function (error) {
                            $(".loading").hide();
                            console.log(error);
                        });
                }
            });
        },
        excluiSubRota() {
            var vm = this;
            vm.$swal({
                title: "Realmente dessa deletar esta subrota?",
                text: "Esta ação não poderá ser revertida",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim, Deletar!",
                cancelButtonText: "Não, cancelar!",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    axios
                        .post("/adm/rotas/edit/" + vm.roteiro_id + "/rmsubrota", {})
                        .then(function (response) {
                            let obj = response.data;
                            $(".loading").hide();
                            vm.$swal("Ok", obj.success, "success");
                            window.location.href = "/adm/rotas";
                        })
                        .catch(function (error) {
                            $(".loading").hide();
                            console.log(error);
                        });
                }
            });
        },
    },
    computed: {
        orderedUsers() {
            return _.orderBy(this.listaRota, "id");
        },
        orderSubrota() {
            return _.orderBy(this.listaSubRota, "data");
        },
    },
    mounted() {
        delete Icon.Default.prototype._getIconUrl;
        Icon.Default.mergeOptions({
            iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
            iconUrl: require('leaflet/dist/images/marker-icon.png'),
            shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        });
        this.getLoad();
        this.getParametros();
    },
};
</script>

<style>
/*@import '~leaflet-routing-machine/dist/leaflet-routing-machine.css';*/
html {
    font-family: sans-serif;
    font-size: 11pt;
}

.leaflet-routing-container,
.leaflet-routing-error {
    width: 320px;
    background-color: white;
    padding-top: 4px;
    transition: all 0.2s ease;
    box-sizing: border-box;
}

.leaflet-control-container .leaflet-routing-container-hide {
    width: 32px;
    height: 32px;
}

.leaflet-routing-container h2 {
    font-size: 14px;
}

.leaflet-routing-container h3 {
    font-size: 12px;
    font-weight: normal;
}

.leaflet-routing-collapsible .leaflet-routing-geocoders {
    margin-top: 20px;
}

.leaflet-routing-alt,
.leaflet-routing-geocoders,
.leaflet-routing-error {
    padding: 6px;
    margin-top: 2px;
    margin-bottom: 6px;
    border-bottom: 1px solid #ccc;
    max-height: 320px;
    overflow-y: auto;
    transition: all 0.2s ease;
}

.leaflet-control-container .leaflet-routing-container-hide .leaflet-routing-alt,
.leaflet-control-container .leaflet-routing-container-hide .leaflet-routing-geocoders {
    display: none;
}

.leaflet-bar .leaflet-routing-alt:last-child {
    border-bottom: none;
}

.leaflet-routing-alt-minimized {
    color: #888;
    max-height: 64px;
    overflow: hidden;
    cursor: pointer;
}

.leaflet-routing-alt table {
    border-collapse: collapse;
}

.leaflet-routing-alt tr:hover {
    background-color: #eee;
    cursor: pointer;
}

.leaflet-routing-alt::-webkit-scrollbar {
    width: 8px;
}

.leaflet-routing-alt::-webkit-scrollbar-track {
    border-radius: 2px;
    background-color: #eee;
}

.leaflet-routing-alt::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background-color: #888;
}

.leaflet-routing-icon {
    /* background-image: url('leaflet.routing.icons.png');*/
    -webkit-background-size: 240px 20px;
    background-size: 240px 20px;
    background-repeat: no-repeat;
    margin: 0;
    content: "";
    display: inline-block;
    vertical-align: top;
    width: 20px;
    height: 20px;
}

.leaflet-routing-icon-continue {
    background-position: 0 0;
}

.leaflet-routing-icon-sharp-right {
    background-position: -20px 0;
}

.leaflet-routing-icon-turn-right {
    background-position: -40px 0;
}

.leaflet-routing-icon-bear-right {
    background-position: -60px 0;
}

.leaflet-routing-icon-u-turn {
    background-position: -80px 0;
}

.leaflet-routing-icon-sharp-left {
    background-position: -100px 0;
}

.leaflet-routing-icon-turn-left {
    background-position: -120px 0;
}

.leaflet-routing-icon-bear-left {
    background-position: -140px 0;
}

.leaflet-routing-icon-depart {
    background-position: -160px 0;
}

.leaflet-routing-icon-enter-roundabout {
    background-position: -180px 0;
}

.leaflet-routing-icon-arrive {
    background-position: -200px 0;
}

.leaflet-routing-icon-via {
    background-position: -220px 0;
}

.leaflet-routing-geocoders div {
    padding: 4px 0px 4px 0px;
}

.leaflet-routing-geocoders input {
    width: 303px;
    width: calc(100% - 4px);
    line-height: 1.67;
    border: 1px solid #ccc;
}

.leaflet-routing-geocoders button {
    font: bold 18px "Lucida Console", Monaco, monospace;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: white;
    margin: 0;
    margin-right: 3px;
    float: right;
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.leaflet-routing-add-waypoint:after {
    content: "+";
}

.leaflet-routing-reverse-waypoints:after {
    font-weight: normal;
    content: "\21c5";
}

.leaflet-routing-geocoders button:hover {
    background-color: #eee;
}

.leaflet-routing-geocoders input,
.leaflet-routing-remove-waypoint,
.leaflet-routing-geocoder {
    position: relative;
}

.leaflet-routing-geocoder-result {
    font: 12px/1.5 "Helvetica Neue", Arial, Helvetica, sans-serif;
    position: absolute;
    max-height: 0;
    overflow: hidden;
    transition: all 0.5s ease;
    z-index: 1000;
    /* Arbitrary, but try to be above "most" things. */
}

.leaflet-routing-geocoder-result table {
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 0 0 4px 4px;
    background-color: white;
    cursor: pointer;
}

.leaflet-routing-geocoder-result-open {
    max-height: 800px;
}

.leaflet-routing-geocoder-selected,
.leaflet-routing-geocoder-result tr:hover {
    background-color: #eee;
}

.leaflet-routing-geocoder-no-results {
    font-style: italic;
    color: #888;
}

.leaflet-routing-remove-waypoint {
    background-color: transparent;
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
}

.leaflet-routing-remove-waypoint:after {
    position: absolute;
    display: block;
    width: 15px;
    height: 1px;
    z-index: 1;
    right: 1px;
    top: 4px;
    bottom: 0;
    margin: auto;
    padding: 2px;
    font-size: 18px;
    font-weight: bold;
    content: "\00d7";
    text-align: center;
    cursor: pointer;
    color: #ccc;
    background: white;
    padding-bottom: 16px;
    margin-top: -16px;
    padding-right: 4px;
    line-height: 1;
}

.leaflet-routing-remove-waypoint:hover {
    color: black;
}

.leaflet-routing-instruction-distance {
    width: 48px;
}

.leaflet-routing-collapse-btn {
    position: absolute;
    top: 0;
    right: 6px;
    font-size: 24px;
    color: #ccc;
    font-weight: bold;
}

.leaflet-routing-collapse-btn:after {
    content: "\00d7";
}

.leaflet-routing-container-hide .leaflet-routing-collapse-btn {
    position: relative;
    left: 4px;
    top: 4px;
    display: block;
    width: 26px;
    height: 23px;
    /* background-image: url('routing-icon.png');*/
}

.leaflet-routing-container-hide .leaflet-routing-collapse-btn:after {
    content: none;
}

.leaflet-top .leaflet-routing-container.leaflet-routing-container-hide {
    margin-top: 10px !important;
}

.leaflet-right .leaflet-routing-container.leaflet-routing-container-hide {
    margin-right: 10px !important;
}

.leaflet-bottom .leaflet-routing-container.leaflet-routing-container-hide {
    margin-bottom: 10px !important;
}

.leaflet-left .leaflet-routing-container.leaflet-routing-container-hide {
    margin-left: 10px !important;
}

@media only screen and (max-width: 640px) {
    .leaflet-routing-container {
        margin: 0 !important;
        padding: 0 !important;
        width: 100%;
        height: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/rotas/EditRota.vue